import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  brands: {
    consumersenergy: {
      baseUrl: 'https://past-dispatches.preprd-apps.enelx.com/v2',
      globalNavUrl: 'https://global-nav.preprd-svcs.enelx.net/api/v1',
    },
    enelx: {
      baseUrl: 'https://past-dispatches.preprd-apps.enelx.com/v2',
      globalNavUrl: 'https://global-nav.preprd-svcs.enelx.net/api/v1',
    },
    demo: {
      baseUrl: 'https://past-dispatches.preprd-apps.enelx.com/v2',
      globalNavUrl: 'https://global-nav.preprd-svcs.enelx.net/api/v1',
    }
  },
  cdn: 'https://cdn.dev-apps.enelx.net',
  defaults: {
    brand: 'enelx',
    locale: 'en-us',
    apiLocale: 'en_US',
  },
};
